import styled from 'styled-components';
import { theme } from '../../../../../global';

export const MenuContainer = styled.div`
  width: 100vw;
  min-height: calc(100vh - 72px);
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media (min-width: 1100px) {
    width: 0px;
    height: 0px;
    position: absolute;
    right: -100px;
  }
`;

export const MenuButton = styled.button`
  background-color: transparent;
  width: ${theme.spacings.s32};
  height: ${theme.spacings.s32};
  cursor: pointer;
  padding-left: ${theme.spacings.s20};

  svg {
    width: 44px;
    height: 24px;
  }
`;

export const Line = styled.hr`
  border-top: 1px solid ${theme.colors.line};
  width: calc(100vw - ${theme.spacings.s32});
  margin: 0 auto;
`;

export const MainLine = styled.hr`
  border-top: 1px solid #d3d3d3;
  width: calc(100vw - ${theme.spacings.s32});
  align-self: center;
`;
export const MainButtonsWrapper = styled.div`
  background-color: ${theme.colors.header};
  display: flex;
  flex-direction: column;
`;

export const ButtonLinkWrapper = styled.p`
  padding: ${theme.spacings.s20} ${theme.spacings.s16};
  background-color: ${theme.colors.header};
`;

export const ButtonLink = styled.a`
  font-weight: 700;
  font-family: 'Montserrat';
  color: ${theme.colors.white};
  font-size: 16px;
  line-height: 20px;

  &:hover {
    color: ${theme.colors.white};
  }
`;

export const MainMenuButton = styled.p`
  padding: ${theme.spacings.s20} ${theme.spacings.s16};

  a {
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #53555f;

    &:hover {
      color: #53555f;
      font-family: Montserrat;
      text-decoration: underline;
      text-decoration-style: solid;
    }
  }
`;
